module.exports = __webpack_public_path__ + "static/media/pBNB.b7a952f2.svg";